import * as React from "react"

const SvgIndex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#14181F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.917 9.466c1.36.32 2.333 1.185 2.333 2.2M.75 11.667c0-1.289 1.567-2.333 3.5-2.333s3.5 1.044 3.5 2.333M7.75 7.583a2.333 2.333 0 0 0 0-4.667M4.25 7.583a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666Z"
    />
  </svg>
);
export default SvgIndex;